// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "Quiz-module--backgroundContainmentImage--83eb8";
export var backgroundImage = "Quiz-module--backgroundImage--6484b";
export var content = "Quiz-module--content--709b3";
export var contentWrapper = "Quiz-module--contentWrapper--b076e";
export var country = "Quiz-module--country--a1d88";
export var formSubmit = "Quiz-module--formSubmit--d2876";
export var gameArea = "Quiz-module--gameArea--ae735";
export var header = "Quiz-module--header--fde05";
export var headerRow = "Quiz-module--headerRow--e541c";
export var heading = "Quiz-module--heading--51511";
export var moreRow = "Quiz-module--moreRow--abd80";
export var moreScoreLink = "Quiz-module--moreScoreLink--959dc";
export var name = "Quiz-module--name--71bba";
export var option = "Quiz-module--option--de8f1";
export var personalArea = "Quiz-module--personalArea--db2d0";
export var personalData = "Quiz-module--personalData--b15b1";
export var personalHeading = "Quiz-module--personalHeading--ae10f";
export var question = "Quiz-module--question--61001";
export var quizForm = "Quiz-module--quizForm--9103d";
export var quizFormField = "Quiz-module--quizFormField--a4b3a";
export var rank = "Quiz-module--rank--36675";
export var row = "Quiz-module--row--53dd8";
export var rowOptions = "Quiz-module--rowOptions--0d66c";
export var score = "Quiz-module--score--33f3f";
export var scoreRow = "Quiz-module--scoreRow--8facb";
export var submit = "Quiz-module--submit--56f9b";
export var submitButton = "Quiz-module--submitButton--3924b";
export var title = "Quiz-module--title--72547";
export var titleRow = "Quiz-module--titleRow--ae3b5";
export var winner = "Quiz-module--winner--1795a";
export var wrapper = "Quiz-module--wrapper--a88dd";